import { combineSlices } from "@reduxjs/toolkit";
import loginReducer from "./login/loginSlice";
import fetchDoctorAppointmentsReducer from "./appointments/doctorAppointmentsSlice";
import updateOnsiteScheduleReducer from "./updateOnsiteSchedule/updateOnsiteScheduleSlice";
import requestAppointmentRescheduleReducer from "./requestAppointmentReschedule/requestAppointmentRescheduleSlice";
import createFollowupAppointmentReducer from "./createFollowupAppointment/createFollowupAppointmentSlice";
import notificationsReducer from "./notifications/notificationsSlice";
import dashboardMetricsReducer from "./dashboard/dashboardMetricsSlice";
import pendingOrdersReducer from "./dashboard/pendingOrdersSlice";
import ongoingOrdersReducer from "./dashboard/ongoingOrdersSlice";
import nurseOrdersReducer from "./orderManagement/nurseOrdersSlice";
import nurseManagementReducer from "./nurseManagement/nurseManagementSlice";
import nurseProfileReducer from "./profile/nurseProfileSlice";
import nurseServicesReducer from "./services/nurseServicesSlice";
import nursePackagesReducer from "./packages/nursePackagesSlice";
import nurseEarningsReducer from "./earnings/nurseEarningsSlice";
import payoutAccountReducer from "./payoutAccount/payoutAccountSlice";

export default combineSlices({ 
    login: loginReducer,
    fetchDoctorAppointments: fetchDoctorAppointmentsReducer,
    updateOnsiteSchedule: updateOnsiteScheduleReducer,
    requestAppointmentReschedule: requestAppointmentRescheduleReducer,
    createFollowupAppointment: createFollowupAppointmentReducer,
    notifications: notificationsReducer,
    dashboardMetrics: dashboardMetricsReducer,
    pendingOrders: pendingOrdersReducer,
    ongoingOrders: ongoingOrdersReducer,
    nurseOrders: nurseOrdersReducer,
    nurseManagement: nurseManagementReducer,
    nurseProfile: nurseProfileReducer,
    nurseServices: nurseServicesReducer,
    nursePackages: nursePackagesReducer,
    nurseEarnings: nurseEarningsReducer,
    payoutAccount: payoutAccountReducer,
});
